export const roleTableColumns = [
  {
    label: "项目角色",
    value: "name"
  },
  {
    label: "角色描述",
    value: "description"
  },
  {
    label: "主负责人",
    value: "mainRoleUser"
  },
  {
    label: "人数",
    value: "count"
  }
]

export const memberTableColumns = [
  {
    label: "姓名",
    value: "user.name"
  },
  {
    label: "手机号",
    value: "user.telephone"
  },
  {
    label: "项目角色",
    value: "roleStr"
  }
]
